import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(website)/components/Header.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/Logo.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/IubendaLink.tsx");
